import React, { useEffect, useState } from 'react';

const ChatDisplayButton = ({ toggleChat, defaultSetting=true }) => {
  const [isOn, setIsOn] = useState(defaultSetting);
  const [showTooltip, setShowTooltip] = useState(false);

  const toggleSwitch = () => {
    setIsOn(!isOn);
    toggleChat();
  };

  useEffect(() => {
    setIsOn(defaultSetting);
  }, [defaultSetting])

  return (
    <div
      className="flex space-x-2 relative pt-[3px] mt-[3px]"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <button
        className={`relative w-11 h-6 rounded-full transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 ml-3 mb-1 ${
          isOn ? 'bg-green-500' : 'bg-gray-300'
        }`}
        onClick={toggleSwitch}
        aria-checked={isOn}
        role="switch"
      >
        <span
          className={`absolute left-0 top-1 w-4 h-4 rounded-full bg-white transition-transform duration-300 ${
            isOn ? 'transform translate-x-6 left-0' : 'left-1'
          }`}
        />
      </button>
      {showTooltip ? (
        <span className="absolute top-[110%] left-1/2 transform -translate-x-1/2 bg-gray-600 text-white text-xs py-2 px-2 rounded shadow-md w-[140px]">
          {isOn ? "チャット欄を閉じる" : "チャット欄を表示する"}
        </span>
      ) : null}
    </div>
  );
};

export default ChatDisplayButton;
